import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { CircularProgress } from '@mui/material';
import getTimeStamp from '../../utils/getTimeStamp';
import { globalCards } from '../../utils/global.card';
import { ADD_EVENT } from '../../redux/reducers/eventReducer';
import ChatBotTemplate from '../chatBotTemplate/ChatBotTemplate';
import { AppDispatch } from '../../redux/store';
import { generateRandomId } from '../../utils/global.utils';

interface CalendlyCardProps {
  option: any;
}

const CalendlyCard: React.FC<CalendlyCardProps> = ({ option }) => {
  const timeStampRef = useRef('');
  timeStampRef.current = getTimeStamp();
  const dispatch = useDispatch<AppDispatch>();

  const LoadingSpinner = () => {
    return (
      <div className="py-26 bg-white">
        <span className="px-4">Loading...</span>
        <CircularProgress size={25} color="inherit" />
      </div>
    );
  };

  useCalendlyEventListener({
    onProfilePageViewed: () => {
      console.log('onProfilePageViewed');
      // setIsLoading(false);
    },

    onEventScheduled: () => {
      const feedbackCard = globalCards['feedback_card'];
      const timeStamp = getTimeStamp();
      const divId = generateRandomId();
      dispatch({
        type: ADD_EVENT,
        payload: {
          ...feedbackCard,
          id: divId,
          divId,
          user: 'actionCard',
          time: timeStamp,
          senderType: 'chatBot',
        },
      });
    },
  });
  let calendlyUrl= "";

  switch (option) {
    case "calendlyWidget":
      calendlyUrl= "https://calendly.com/tax1099-live-demo/group?month=2025-10"
      break;
    case "calendlyWidgetIntroCall":
      calendlyUrl= "https://calendly.com/tax1099-team/tax1099-ai-meeting?month=2025-10"
      break;
    default:
      calendlyUrl= "https://calendly.com/tax1099-live-demo/group?month=2025-10"
  }
  return (
    <ChatBotTemplate timeStamp={timeStampRef.current}>
      <InlineWidget
        url= {calendlyUrl}
        LoadingSpinner={LoadingSpinner}
      />
    </ChatBotTemplate>
  );
};
export default CalendlyCard;